import { Box, Button, Card, CardBody, Flex } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { getQuestions } from 'src/view-models/Question'
import CategoriesQuestions from './categories/CategoriesQuestions'
import QuestionsView from './questions/QuestionsView'
import Loading from 'src/components/loading/Loading'
import { useNavigate } from 'react-router-dom'
import { FaArrowLeft } from 'react-icons/fa6'
import CategoriesMenuBar from './categories/CategoriesMenuBar'
import LanguagesBar from 'src/pages/patient/components/LanguagesBar'

export enum STEPS {
  FIRST_sTEP = 0,
  SECOND_STEP = 1,
  THIRD_STEP = 2
}

const QuestionsPatienteView = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(true)
  const [step, setStep] = useState(STEPS.FIRST_sTEP)

  const localStorageLanguage = localStorage.getItem("language")
  const [patienteLanguage, _] = useState<{ code: string, label: string } | null>(localStorageLanguage ? JSON.parse(localStorageLanguage) : null)
  const [isLoadingTranslate, setIsLoadingTranslate] = useState(false)

  useEffect(() => {
    const fetchQuestions = async () => {
      await getQuestions(dispatch, patienteLanguage?.code)
      setIsLoading(false)
    }
    fetchQuestions()
  }, [])

  const goBack = () => {
    navigate("/admin/questions")
  }

  if (isLoading) {
    return <Loading />
  }

  return (
    <Box sx={{ width: "95%", mx: "auto", height: "90vh", overflowY: "hidden" }}>
      <Card sx={{ mt: "4vh", height: "91%", overflowY: "hidden" }} >
        <CardBody sx={{ height: "100%" }}>
          <Box>
            <CategoriesMenuBar step={step} setStep={setStep} />
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <Button leftIcon={<FaArrowLeft />} onClick={goBack}>Retour</Button>
              <LanguagesBar 
                setIsLoadingTranslate={setIsLoadingTranslate} 
                isLoadingTranslate={isLoadingTranslate}
                />
            </Box>
          </Box>
          <Flex gap={4} sx={{ height: "100%" }}>
            
              <>
                <CategoriesQuestions step={step} setStep={setStep} />
                <Box flex={4} mt={4} pr={4} sx={{ height: "95%", overflowY: "auto" }}>
                  <QuestionsView step={step} setStep={setStep} isLoadingTranslate={isLoadingTranslate} />
                </Box>
              </>
            
          </Flex>
        </CardBody>
      </Card>
    </Box>
  )
}

export default QuestionsPatienteView